import React from "react";

// Components Imports
import { NumberInput } from "../../revvComponents";

// Component
export default function ResourceListing(props) {
  const { data, index, onChange, readOnly } = props;
  // Render Section
  return (
    <div className="bundlerow-wrapper">
      <div className="bundlerow-input-wrapper">
        <div className="bundlerow-input is-bundle ">{data.sku}</div>
        <NumberInput
          className="bundlerow-input"
          placeholder="Enter Value"
          isFloat
          onChange={value => onChange(index, value)}
          value={data.months}
          disabled={readOnly}
          data-test="resourcelisting-number-input"
        />
      </div>
    </div>
  );
}
